<template>
  <div class="c-entrepreneur-video-asset">
    <a
      v-cursor.rotate="{ label: $t('shared.cursor.watch') }"
      class="c-entrepreneur-video-asset__inner"
      @click="openLightBox"
    >
      <asset class="c-entrepreneur-video-asset__inner__video" :image="image" />
      <entrepreneur-video-decorative />
    </a>
  </div>
</template>

<script>
import Asset from "objects/Asset";
import EntrepreneurVideoDecorative from "components/EntrepreneurVideo/EntrepreneurVideoDecorative/EntrepreneurVideoDecorative";

export default {
  components: {
    Asset,
    EntrepreneurVideoDecorative
  },
  props: {
    image: {
      type: Object,
      required: true
    },
    videoId: {
      type: Array,
      required: false,
      default: () => {}
    },
    videoDescription: {
      type: Array,
      required: false,
      default: () => {}
    }
  },
  methods: {
    openLightBox() {
      this.setLightBoxInfo();
      this.toggleLightBox();
    },
    setLightBoxInfo() {
      this.$store.commit("lightBox/UPDATE_YOUTUBE_ID", this.videoId[0].text);
      this.$store.commit("lightBox/UPDATE_COPY", this.videoDescription);
    },
    toggleLightBox() {
      this.$store.commit("lightBox/TOGGLE_LIGHT_BOX", true);
    }
  }
};
</script>

<style lang="scss">
.c-entrepreneur-video-asset {
  display: flex;
  position: relative;
  width: 100%;

  &__inner {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    z-index: 1;
    /* cursor: pointer; */
    cursor: none !important;
    @media #{$breakpoint-horizontal} {
      flex-direction: column;
    }
    &__video {
      /* width: calc(100% + 1.25em * 2); */
      /* margin-left: calc(0px - val(--grid-gutter)); */
      /* width: 1000px; */
      /* picture {
        width: 100vw;
      } */
      /* @media #{$breakpoint-horizontal} {
        width: 100%;
      } */
      width: 100%;
      order: 2;
      @media #{$breakpoint-horizontal} {
        order: 1;
      }
    }

    &__decorative {
      position: relative;
      width: 100%;
      height: 100%;
      order: 1;
      display: flex;
      justify-content: center;
      @media #{$breakpoint-horizontal} {
        position: absolute;
        top: 0px;
        order: 2;
      }
    }
  }
}
</style>
